module.exports = __webpack_public_path__ + "img/doubleSideTriangleHorizontal.57b0aca9.svg";